import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { SettingsProvider } from './Settings';
import { BrandProvider } from './Brand';
import { SessionProvider } from './Session';
import { I18nProvider } from './i18n';
import { AppRoutes } from './layouts';
import { FeedbackProvider } from './components/common/Feedback';
import { theme } from './theme';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <I18nProvider>
          <SettingsProvider>
            <BrandProvider>
              <SessionProvider>
                <FeedbackProvider>
                  <AppRoutes />
                </FeedbackProvider>
              </SessionProvider>
            </BrandProvider>
          </SettingsProvider>
        </I18nProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
